module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/mobile-marquee-3-image-1-1-edf8f67bf46cacf9567ed8b1a05ba844.png";